export default __webpack_public_path__ + "fonts/arrow-white-right.svg";